export default __webpack_public_path__ + "static/media/iconHomeActive.8a0fd460.svg";